import Image from "next/image";
import { Fragment, useState } from "react";
import { ArticleFilterProps } from "../types";

const ArticleFilter = ({ categories, setSelectedCategory }: ArticleFilterProps) => {
  const [isOpened, setSelectOpened] = useState(false);
  const [categoryName, setCategoryName] = useState("ALL ARTICLES");

  const onClick = () => {
    setSelectOpened(!isOpened);
  };

  return (
    <div className="flex lg:hidden sticky top-0 z-40 w-full text-white font-bold">
      <div
        className={`bg-magenta ${
          isOpened ? "rounded-tl-3xl rounded-tr-3xl" : "rounded-full"
        } px-5 py-4 w-full flex justify-between text-base`}
        onClick={onClick}
      >
        {categoryName}
        <Image
          src="/koach/chevron-white-bottom.svg"
          width={15}
          height={15}
          alt="down chevron"
          className={`transition-all duration-300 ease-in-out ${
            isOpened === true ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <div
        onClick={onClick}
        className={` ${
          isOpened ? "block" : "hidden"
        } absolute z-50 w-full mt-11 pt-2 bg-magenta rounded-bl-3xl rounded-br-3xl`}
      >
         <div
          onClick={() => {
            setCategoryName("ALL ARTICLES");
            setSelectedCategory("all");
          }}
          className={`px-4 py-2 outline-none cursor-pointer focus:bg-grey-50 focus:font-bold hover:bg-landing-blue hover:font-bold ${
            categoryName === "ALL ARTICLES" && "font-bold"
          }`}
        >
          ALL ARTICLES
        </div>
        {categories.map((category, idx) => (
          <Fragment key={idx}>
            <div
              onClick={() => {
                setCategoryName(category.attributes.name);
                setSelectedCategory(category.attributes.slug);
              }}
              className={`px-4 py-2 outline-none cursor-pointer focus:bg-grey-50 focus:font-bold hover:bg-landing-blue hover:font-bold ${
                category.attributes.name === categoryName && "font-bold"
              }`}
            >
              {category.attributes.name}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default ArticleFilter;
